'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (layout, legendSet) {
    return (0, _objectClean2.default)({
        min: 0,
        max: DEFAULT_MAX_VALUE,
        lineWidth: 0,
        minorTickInterval: null,
        tickLength: 0,
        tickAmount: 0,
        labels: {
            y: 18,
            style: {
                fontSize: '13px'
            }
        },
        stops: getStopsByLegendSet(legendSet)
    });
};

var _arraySort = require('d2-utilizr/lib/arraySort');

var _arraySort2 = _interopRequireDefault(_arraySort);

var _isObject = require('d2-utilizr/lib/isObject');

var _isObject2 = _interopRequireDefault(_isObject);

var _objectClean = require('d2-utilizr/lib/objectClean');

var _objectClean2 = _interopRequireDefault(_objectClean);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_MAX_VALUE = 100;

function getStopsByLegendSet(legendSet) {
    return (0, _isObject2.default)(legendSet) ? (0, _arraySort2.default)(legendSet.legends, 'ASC', 'endValue').map(function (legend) {
        return [parseFloat(legend.endValue) / DEFAULT_MAX_VALUE, legend.color];
    }) : undefined;
}
//# sourceMappingURL=gauge.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-charts-api/lib/config/adapters/dhis_highcharts/yAxis/gauge.js
 ** module id = 209
 ** module chunks = 0 1
 **/